/* eslint-disable @typescript-eslint/no-floating-promises */
export const builder_fullwidthVideo = (): void => {
  const builder_fullwidthVideo_components = document.querySelectorAll('.js-builder_fullwidthVideo') as unknown as HTMLElement[]

  builder_fullwidthVideo_components.forEach(component => {
    const triggerElement = component.querySelector('.js-builder_fullwidthVideo_videoTrigger') as HTMLElement
    const videoElement = component.querySelector('.js-builder_fullwidthVideo_video') as HTMLVideoElement

    if (window.innerWidth > 768 && !videoElement.classList.contains('no-autoPlay')) {
      videoElement.setAttribute('controls', '')
      videoElement.setAttribute('autoplay', '')
      videoElement.play()

      triggerElement.remove()
    }

    if (window.innerWidth > 768 && videoElement.classList.contains('no-autoPlay')) {
      videoElement.setAttribute('controls', '')
      triggerElement.remove()
    }

    if (!triggerElement) return

    triggerElement.addEventListener('click', () => {
      triggerElement.remove()
      videoElement.setAttribute('controls', '')
      videoElement.muted = false
      videoElement.play()
    })
  }) }
